import { useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { generateHmac } from '../../graphql'
import { UserType } from '../../types'

export const useIntercom = () => {
  const w = window as any
  const apollo = useApolloClient()
  const [hmac, setHmac] = useState<string>()

  const getHmac = async () => {
    try {
      const { data } = await apollo.query({
        fetchPolicy: 'no-cache',
        query: generateHmac
      })

      setHmac(data.generateHmac)

      return data.generateHmac
    } catch (err) {
      console.log(err)
    }
  }

  const updateIntercomUser = async (user: UserType) => {
    try {
      const hash = hmac || (await getHmac())

      if (!hash || !user) {
        return
      }

      const attributes = {
        name: user.displayName,
        user_id: user?.stripeCustomerId,
        email: user?.email,
        trial: user?.trial,
        has_trialed: user?.hasTrialed,
        last_request_at: new Date().getTime() / 1000,
        user_created_at: user?.createdAt?.seconds,
        stripe_subscription_status: user.stripeSubscriptionStatus,
        subscription_interval: user.subscriptionInterval,
        stripe_customer_id: user.stripeCustomerId,
        course: user.course,
        user_hash: hash
      }

      w.Intercom('update', attributes)
    } catch (err) {
      console.log(err)
    }
  }

  const showIntercomMessenger = async () => {
    w.Intercom('show')
  }

  const updateIntercom = async (params: any) => {
    w.Intercom('update', params)
  }

  const logoutIntercom = async () => {
    w.Intercom('shutdown')
  }

  return {
    updateIntercom,
    updateIntercomUser,
    showIntercomMessenger,
    logoutIntercom
  }
}
